module.exports = __webpack_public_path__ + "media/AeorionSoftwareSolutions.fae6dcd2.mp4";